import { render, staticRenderFns } from "./EfsMdFarmerForm.vue?vue&type=template&id=48ccef92&"
import script from "./EfsMdFarmerForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdFarmerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports